"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DividerStyles = require("./Divider-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Divider(props) {
  let {
    size,
    line,
    weight
  } = props;
  return /*#__PURE__*/_react.default.createElement(_DividerStyles.DividerContainer, {
    size: size
  }, line && /*#__PURE__*/_react.default.createElement(_DividerStyles.Line, {
    line: line,
    weight: weight
  }));
}

Divider.defaultProps = {
  size: "m"
};
var _default = Divider;
exports.default = _default;